module.exports = __webpack_public_path__ + "img/img001.00f69a3a.png";